import { GenericValidator } from '../../../../../../utils/genericValidator.util';
import { OfflineOrderProduct } from '../OfflineOrderProduct';
import { CreateOrderProductRulesParams } from './offlineOrderProduct.types';

export class OfflineOrderProductValidator extends GenericValidator<
  OfflineOrderProduct,
  CreateOrderProductRulesParams
> {}
